import React from 'react'

interface AgentFormFieldProps {
  label: string
  children: React.ReactNode
  style?: React.CSSProperties
}

export const AgentFormField: React.FC<AgentFormFieldProps> = ({ label, children, style }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', ...style }}>
    <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)' }}>
      {label}
    </label>
    {children}
  </div>
)
